<!-- Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. -->
<div
	class="timeline-ticket-overflow"
	[style.display]="(overflowViewModel$ | async)?.visible ? 'block' : 'none'"
	[style.position]="'absolute'"
	[style.left.px]="(overflowViewModel$ | async)?.position.x"
	[style.top.px]="(overflowViewModel$ | async)?.position.y"
	[style.z-index]="9999"
>
	<div class="timeline-ticket-container">
		<div class="timeline-ticket-arrow"></div>

		<div
			*ngFor="let displayTicket of (overflowViewModel$ | async)?.displayTickets; trackBy: trackByTicketId"
			class="timeline-ticket-item"
			[attr.data-element-type]="'timeline-group-ticket'"
			[attr.automationId]="'timelineGroupTicket'"
		>
			<!-- used to be an attribute in the below div, but isSemiSelected is never set -->
			<!-- [class.semi-selected]="displayTicket.isSemiSelected" -->
			<div
				class="timeline-group-bullet timeline-ticket"
				[class]="displayTicket.backgroundClass"
				[class.timeline-diamond]="displayTicket.isMilestone"
				[class.timeline-dot]="displayTicket.isConstraint"
				[class.relationSelected]="displayTicket.isSelected"
				[attr.automationId]="'timelineTicket'"
				(click)="processTimelineTicketClicked(displayTicket)"
				style="display: inline-block; vertical-align: middle"
			></div>

			<span class="timeline-ticket-label">{{ displayTicket.activityName }}</span>

			<div
				*ngIf="displayTicket.isDifferentPlan"
				class="timeline-ticket-jump-to"
				[attr.data-element-type]="'timeline-ticket-redirect'"
				(click)="navigateToPlan(displayTicket.ticket.timelineTicketSplitId[0])"
			>
				<i class="material-icons notranslate">redo</i>
			</div>

			<div class="clear"></div>
		</div>
	</div>
</div>
